"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddressFromTaggedIdentity = exports.getAccountFeaturesData = exports.getAccountRolesData = exports.makeAccountInfoData = exports.makeTxnData = exports.getEventTypeNameFromIndices = exports.makeLedgerSendParam = void 0;
const const_1 = require("../../const");
const identity_1 = require("../../identity");
const network_1 = require("../../network");
function makeLedgerSendParam({ from, to, symbol, amount, }) {
    const m = new Map();
    from && m.set(0, from);
    return m.set(1, to).set(2, amount).set(3, symbol);
}
exports.makeLedgerSendParam = makeLedgerSendParam;
async function getEventTypeNameFromIndices(indices) {
    const indicesJson = JSON.stringify(indices);
    for (let k of Object.keys(const_1.eventTypeNameToIndices)) {
        const val = JSON.stringify(const_1.eventTypeNameToIndices[k]);
        if (indicesJson === val) {
            return k;
        }
    }
}
exports.getEventTypeNameFromIndices = getEventTypeNameFromIndices;
async function makeTxnData(txn, opts) {
    const indices = txn.get(0);
    const eventTypeName = await getEventTypeNameFromIndices(indices);
    if (eventTypeName === network_1.EventType.send)
        return await makeSendEventData(txn, opts);
    else if (eventTypeName === network_1.EventType.accountCreate) {
        return await makeCreateAccountEventData(txn);
    }
    else if (eventTypeName === network_1.EventType.accountAddFeatures) {
        return await makeAddFeaturesEventData(txn);
    }
    else if (eventTypeName === network_1.EventType.accountSetDescription) {
        return await makeSetDescriptionEventData(txn);
    }
    else if (eventTypeName === network_1.EventType.accountAddRoles ||
        eventTypeName === network_1.EventType.accountRemoveRoles) {
        return await makeEditRolesEventData(txn, eventTypeName);
    }
    else if (eventTypeName === network_1.EventType.accountMultisigSubmit)
        return await makeMultisigSubmitEventData(txn);
    else if (eventTypeName === network_1.EventType.accountMultisigApprove)
        return await makeMultisigEventData(network_1.EventType.accountMultisigApprove, "approver", txn);
    else if (eventTypeName === network_1.EventType.accountMultisigRevoke)
        return await makeMultisigEventData(network_1.EventType.accountMultisigRevoke, "revoker", txn);
    else if (eventTypeName === network_1.EventType.accountMultisigExecute)
        return await makeMultisigEventData(network_1.EventType.accountMultisigExecute, "executor", txn);
    else if (eventTypeName === network_1.EventType.accountMultisigWithdraw)
        return await makeMultisigEventData(network_1.EventType.accountMultisigWithdraw, "withdrawer", txn);
    else if (eventTypeName === network_1.EventType.accountMultisigSetDefaults)
        return await makeMultisigSetDefaultEventData(txn);
    else if (eventTypeName === network_1.EventType.mint)
        return await makeMintEventData(txn);
    else if (eventTypeName === network_1.EventType.burn)
        return await makeBurnEventData(txn);
    else if (eventTypeName === network_1.EventType.tokenCreate)
        return await makeTokenCreateEventData(txn);
    console.error("event type not implemented", indices, txn);
}
exports.makeTxnData = makeTxnData;
async function makeSetDescriptionEventData(eventData) {
    var _a;
    return {
        type: network_1.EventType.accountSetDescription,
        account: (_a = eventData.get(1)) === null || _a === void 0 ? void 0 : _a.toString(),
        description: eventData.get(2),
    };
}
async function makeEditRolesEventData(eventData, eventTypeName) {
    var _a;
    const res = {
        type: eventTypeName,
        account: (_a = eventData.get(1)) === null || _a === void 0 ? void 0 : _a.toString(),
        roles: getAccountRolesData(eventData.get(2)),
    };
    return res;
}
async function makeMultisigSetDefaultEventData(eventData) {
    var _a, _b;
    return {
        type: network_1.EventType.accountMultisigSetDefaults,
        submitter: (_a = eventData.get(1)) === null || _a === void 0 ? void 0 : _a.toString(),
        account: (_b = eventData.get(2)) === null || _b === void 0 ? void 0 : _b.toString(),
        threshold: eventData.get(3),
        expireInSecs: eventData.get(4),
        executeAutomatically: eventData.get(5),
    };
}
async function makeCreateAccountEventData(eventData) {
    var _a;
    return Object.assign({ type: network_1.EventType.accountCreate, account: (_a = eventData.get(1)) === null || _a === void 0 ? void 0 : _a.toString() }, makeAccountInfoData({
        description: eventData.get(2),
        roles: eventData.get(3),
        features: eventData.get(4),
    }));
}
async function makeAddFeaturesEventData(eventData) {
    var _a;
    const result = {
        type: network_1.EventType.accountAddFeatures,
        account: (_a = eventData.get(1)) === null || _a === void 0 ? void 0 : _a.toString(),
    };
    if (eventData.get(2) instanceof Map) {
        result.roles = getAccountRolesData(eventData.get(2));
    }
    if (eventData.get(3) instanceof Array) {
        result.features = getAccountFeaturesData(eventData.get(3));
    }
    return result;
}
function makeAccountInfoData({ description, roles, features, }) {
    return {
        description,
        roles: getAccountRolesData(roles),
        features: getAccountFeaturesData(features),
    };
}
exports.makeAccountInfoData = makeAccountInfoData;
function getAccountRolesData(roles = new Map()) {
    return Array.from(roles).reduce((acc, roleData) => {
        const [identity, roleList] = roleData;
        const address = identity === null || identity === void 0 ? void 0 : identity.toString();
        if (Array.isArray(roleList) && roleList.length) {
            acc.set(address, roleList);
        }
        return acc;
    }, new Map());
}
exports.getAccountRolesData = getAccountRolesData;
function getAccountFeaturesData(features = []) {
    return features.reduce((acc, feature) => {
        let featureName;
        let featureValue;
        let featureLabelNum;
        if (Array.isArray(feature)) {
            const [featureLabelNum, featureArguments] = feature;
            featureName = network_1.AccountFeatureTypes[featureLabelNum];
            featureValue = makeAccountFeatureArgumentData(featureLabelNum, featureArguments);
        }
        else if (typeof feature === "number") {
            featureLabelNum = feature;
            featureName = network_1.AccountFeatureTypes[feature];
            featureValue = true;
        }
        if (!featureName && featureLabelNum)
            console.error("Account feature not implemented:", featureLabelNum);
        if (featureName && featureValue)
            acc.set(featureName, featureValue);
        return acc;
    }, new Map());
}
exports.getAccountFeaturesData = getAccountFeaturesData;
function makeAccountFeatureArgumentData(feature, argumentData = new Map()) {
    if (feature === network_1.AccountFeatureTypes.accountMultisig) {
        return Array.from(argumentData).reduce((acc, argData) => {
            const [argLabelNum, value] = argData;
            const argName = network_1.AccountMultisigArgument[argLabelNum];
            if (!argName) {
                console.error("Account multisig feature argument not found:", argLabelNum);
                return acc;
            }
            else
                acc.set(argName, value);
            return acc;
        }, new Map());
    }
}
async function makeMultisigEventData(type, actorType, eventData) {
    var _a, _b, _c;
    return {
        type,
        account: (_a = eventData.get(1)) === null || _a === void 0 ? void 0 : _a.toString(),
        token: eventData.get(2),
        [actorType]: (_c = (_b = eventData.get(3)) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : "",
    };
}
async function makeSendEventData(eventData, opts) {
    var _a, _b, _c, _d, _e, _f;
    const { isTxnParamData } = opts || {};
    if (isTxnParamData) {
        eventData = eventData.get(1);
        return {
            type: network_1.EventType.send,
            from: (_a = eventData.get(0)) === null || _a === void 0 ? void 0 : _a.toString(),
            to: (_b = eventData.get(1)) === null || _b === void 0 ? void 0 : _b.toString(),
            symbolAddress: (_c = eventData.get(3)) === null || _c === void 0 ? void 0 : _c.toString(),
            amount: BigInt(eventData.get(2)),
        };
    }
    return {
        type: network_1.EventType.send,
        from: (_d = eventData.get(1)) === null || _d === void 0 ? void 0 : _d.toString(),
        to: (_e = eventData.get(2)) === null || _e === void 0 ? void 0 : _e.toString(),
        symbolAddress: (_f = eventData.get(3)) === null || _f === void 0 ? void 0 : _f.toString(),
        amount: BigInt(eventData.get(4)),
    };
}
async function getAddressFromTaggedIdentity(taggedIdentity) {
    return new identity_1.Address(taggedIdentity.value).toString();
}
exports.getAddressFromTaggedIdentity = getAddressFromTaggedIdentity;
// https://github.com/liftedinit/many-rs/blob/main/src/many/src/types/ledger.rs#L658
async function makeMultisigSubmitEventData(eventData) {
    var _a, _b, _c;
    const submittedTxn = eventData.get(4);
    const transaction = await makeTxnData(submittedTxn, {
        isTxnParamData: true,
    });
    return {
        type: network_1.EventType.accountMultisigSubmit,
        submitter: (_a = eventData.get(1)) === null || _a === void 0 ? void 0 : _a.toString(),
        account: (_b = eventData.get(2)) === null || _b === void 0 ? void 0 : _b.toString(),
        transaction,
        token: eventData.get(5),
        threshold: eventData.get(6),
        expireDate: (_c = eventData.get(7)) === null || _c === void 0 ? void 0 : _c.value,
        executeAutomatically: eventData.get(8),
        memo: eventData.get(10),
    };
}
async function makeMintEventData(eventData) {
    var _a;
    const amounts = eventData.get(2);
    return {
        type: network_1.EventType.mint,
        symbolAddress: (_a = eventData.get(1)) === null || _a === void 0 ? void 0 : _a.toString(),
        amounts: Array.from(amounts.entries()).reduce((amts, [to, amt]) => (Object.assign(Object.assign({}, amts), { [to.toString()]: BigInt(amt) })), {}),
    };
}
async function makeBurnEventData(eventData) {
    var _a;
    const amounts = eventData.get(2);
    return {
        type: network_1.EventType.burn,
        symbolAddress: (_a = eventData.get(1)) === null || _a === void 0 ? void 0 : _a.toString(),
        amounts: Array.from(amounts.entries()).reduce((amts, [from, amt]) => (Object.assign(Object.assign({}, amts), { [from.toString()]: BigInt(amt) })), {}),
    };
}
async function makeTokenCreateEventData(eventData) {
    var _a;
    const initialDistribution = eventData.get(4) || new Map();
    const summaryMap = eventData.get(1);
    const summary = {
        name: summaryMap.get(0),
        symbol: summaryMap.get(1),
        precision: summaryMap.get(2),
    };
    return {
        type: network_1.EventType.tokenCreate,
        summary,
        symbolAddress: eventData.get(2).toString(),
        owner: ((_a = eventData.get(3)) === null || _a === void 0 ? void 0 : _a.toString()) || null,
        initialDistribution: Array.from(initialDistribution).reduce((amts, [from, amt]) => (Object.assign(Object.assign({}, amts), { [from.toString()]: BigInt(amt) })), {}),
        extendedInfo: eventData.get(5),
        maximumSupply: eventData.get(6),
        memo: eventData.get(7),
    };
}
